
<div (click)="toggle()" class="title">
  <mat-icon class="arrow" [class.rotated]="isOpen">expand_more</mat-icon>
  <!-- <mat-icon>lens</mat-icon> -->
  <ng-content select="[title]"></ng-content>
</div>
<div *ngIf="isOpen">
  <ng-content select="[body]"></ng-content>
</div>